import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
import { useSettingsStore } from '@/store/modules/settings';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    collapse: {
      type: Boolean,
      default() {
        return false;
      }
    },
    fixedHeader: {
      type: Boolean,
      default() {
        return true;
      }
    },
    showTabs: {
      type: Boolean,
      default() {
        return true;
      }
    },
    device: {
      type: String,
      default() {
        return 'desktop';
      }
    }
  },
  setup(__props) {
    const settingsStore = useSettingsStore();
    const {
      foldSideBar
    } = settingsStore;
    return (_ctx, _cache) => {
      const _component_vab_side_bar = _resolveComponent("vab-side-bar");
      const _component_vab_nav = _resolveComponent("vab-nav");
      const _component_vab_tabs = _resolveComponent("vab-tabs");
      const _component_vab_app_main = _resolveComponent("vab-app-main");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["vab-layout-vertical", {
          fixed: __props.fixedHeader,
          'no-tabs-bar': !__props.showTabs
        }])
      }, [_createVNode(_component_vab_side_bar), __props.device === 'mobile' && !__props.collapse ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "v-modal",
        onClick: _cache[0] || (_cache[0] =
        //@ts-ignore
        (...args) => _unref(foldSideBar) && _unref(foldSideBar)(...args))
      })) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["vab-main", {
          'is-collapse-main': __props.collapse
        }])
      }, [_createElementVNode("div", {
        class: _normalizeClass(["vab-layout-header", {
          'fixed-header': __props.fixedHeader
        }])
      }, [_createVNode(_component_vab_nav), _withDirectives(_createVNode(_component_vab_tabs, null, null, 512), [[_vShow, __props.showTabs]])], 2), _createVNode(_component_vab_app_main)], 2)], 2);
    };
  }
});